import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
var ImageWrapper = styled.div.withConfig({
  displayName: "ImageOverhangContainer__ImageWrapper",
  componentId: "je0iyt-0"
})(["position:absolute;overflow:initial;width:50%;height:100%;top:0;left:", ";@media only screen and (max-width:", "px){width:100%;position:static;direction:", ";padding-right:", "px;padding-left:", "px;text-align:center;}"], function (_ref) {
  var rightToLeft = _ref.rightToLeft;
  return rightToLeft ? '0' : '50%';
}, spacing.collapseMenuWidth, function (_ref2) {
  var rightToLeft = _ref2.rightToLeft;
  return rightToLeft ? 'rtl' : null;
}, spacing.base, spacing.base);
var Image = styled.img.withConfig({
  displayName: "ImageOverhangContainer__Image",
  componentId: "je0iyt-1"
})(["bottom:-12rem;position:absolute;margin-bottom:0;", " @media only screen and (max-width:", "px){position:static;transform:none;max-width:150%;}"], function (_ref3) {
  var rightToLeft = _ref3.rightToLeft,
      imageOpposite = _ref3.imageOpposite;

  if (rightToLeft && !imageOpposite || !rightToLeft && imageOpposite) {
    return "right: 0;";
  } else {
    return "left: 0;";
  }
}, spacing.collapseMenuWidth);

var ImageOverhangContainer = function ImageOverhangContainer(_ref4) {
  var image = _ref4.image,
      image2x = _ref4.image2x,
      rightToLeft = _ref4.rightToLeft,
      imageOpposite = _ref4.imageOpposite,
      alt = _ref4.alt;
  return React.createElement(ImageWrapper, {
    rightToLeft: rightToLeft
  }, image2x && React.createElement(Image, {
    src: image,
    srcSet: image + " 1x, " + image2x + " 2x",
    rightToLeft: rightToLeft,
    imageOpposite: imageOpposite,
    alt: alt
  }), !image2x && React.createElement(Image, {
    src: image,
    rightToLeft: rightToLeft
  }));
};

export default ImageOverhangContainer;